export class User {
    public id: number;
    public firstName: string;
    public familyName: string;
    protected email: string;
    protected login: string;
    protected password?: string;
    protected language = 'default';
    protected missedCallReport = true;
    protected faxCoverPage = false;
    protected faxEmailJournal = false;
    protected faxCallerId?: string;
    protected faxHeader?: string;

    constructor(firstName: string, familyName: string, email: string, login: string, id: number, password?: string, faxCallerId?: string, faxHeader?: string) {
        this.firstName = firstName;
        this.familyName = familyName;
        this.email = email;
        this.login = login;
        this.password = password;
        this.faxCallerId = faxCallerId;
        this.faxHeader = faxHeader;
        this.id = id;
    }

}
